import { Analysis } from './analysis.service';

export function urlFor(url: string, projectId?: string) {
  return `${projectId ? `/projects/${projectId}` : ``}${url}`;
}

export function getAnalysisDisplayName(analysis: Analysis, projectId?: string) {
  return projectId ? analysis.displayName : analysis.name;
}
